<template>
    <div id="webzine" class="open">
        <router-view />
    </div>
</template>


<script>

export default {
    name: 'Webzine',
    
}
</script>
<style>
html, body {
    margin: 0;
    padding: 0;
    height: 100%;
    width: 100%;

}
</style>
